import { isRTL } from "./isRTL.js";
const targets = /* @__PURE__ */ new Set();
const queuedTargets = /* @__PURE__ */ new Set();
function processQueue() {
  queuedTargets.forEach(updateTarget);
  queuedTargets.clear();
}
function addTarget(target, immediateEvaluation = false) {
  if (immediateEvaluation) {
    updateTarget(target);
  } else {
    queuedTargets.add(target);
    if (queuedTargets.size === 1) {
      queueMicrotask(processQueue);
    }
  }
  targets.add(target);
}
function removeTarget(target) {
  target.removeAttribute("skapa-rtl");
  targets.delete(target);
}
function updateTarget(target) {
  target.toggleAttribute("skapa-rtl", isRTL(target));
}
let notificationDebounceID = -1;
function notifyListeners() {
  cancelAnimationFrame(notificationDebounceID);
  notificationDebounceID = requestAnimationFrame(() => {
    Array.from(targets).map(updateTarget);
  });
}
export {
  addTarget,
  notifyListeners,
  removeTarget
};
